"use client";

import { IFormInput, IFormProps, IFormSubmit } from "@template/components/Form";
import React, { useState } from "react";
import { Form } from "@template/components";
import TabContent from "@template/components/Tabs/TabContent";
import { TabsSectionContainer } from "@template/components/Tabs/styles.ts";
import * as S from "./styles.ts";
import useLink from "@/lib/helpers/useLink.ts";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

type DomainNameSearchBulkProps = {
  input?: Omit<IFormInput, "name">;
  submit?: Omit<IFormSubmit, "onSubmit">;
  href?: string;
};

const DomainNameSearchBackorder = ({
  input,
  submit,
  href = "",
}: DomainNameSearchBulkProps) => {
  const link = useLink();

  const [formValue, setFormValue] = useState({
    search: "",
  });

  const inputs: IFormProps["inputs"] = [
    {
      ...input,
      type: "text",
      name: "search",
    },
  ];

  const handleChange = (vals: any) => {
    setFormValue(vals);
  };

  const onSubmit = () => {
    const { search } = formValue;
    if (!search) return;
    link({
      href: `${href}?search=${search}`,
    });
  };

  return (
    <S.Wrapper>
      <ArchStandaloneSectionComponent
        color="white"
        background="dark"
        withPadding
      />
      <TabsSectionContainer
        style={{
          zIndex: 1,
        }}
      >
        <TabContent>
          <Form
            value={formValue}
            onChange={handleChange}
            inputs={inputs}
            simple
            submit={{
              ...submit,
              text: submit.children,
              style: {
                width: "fit-content",
                marginLeft: "auto",
              },
              ignoreHref: true,
              onSubmit,
            }}
          />
        </TabContent>
      </TabsSectionContainer>
    </S.Wrapper>
  );
};

export default DomainNameSearchBackorder;
